module.exports = __webpack_public_path__ + "img/tour-12.37d30de3.png";